<div #pdfContent class="report-container" id="contentToConvert" 
>
  <div class="page-header">
    <div class="logo-section">
      <img src="assets/images/report-logo.svg" alt="logo" class="logo">
    </div>
    <div class="title-section">
      Historical Analysis of Customer Engagement
    </div>
  </div>

  <div class="page-body-common">
    <ng-content></ng-content>
  </div>
</div>